import type { AllTableCriteria } from '@openx/types/tableCriteria';
import { useDealPromptDomainsContext } from '../utils/context/DealPromptDomainsContext';
import type { DealPromptFilters } from '../utils/types';

export const useAudienceSearchTextFetch = (criteria: AllTableCriteria<DealPromptFilters>) => {
  const { useDealPromptAudienceSearchTextFetch } = useDealPromptDomainsContext();

  const { fetchDealPromptAudienceSearchText } = useDealPromptAudienceSearchTextFetch(criteria);

  return fetchDealPromptAudienceSearchText;
};
